export interface LocationFAQ {
  serviceSlug?: string;
  locationSlug: string;
  questions: { q: string; a: string }[];
}

export const commonFAQTemplates = (
  serviceName: string,
  city: string,
  country: string,
  timezone: string
) => [
  {
    q: `How do you manage ${serviceName} projects for ${city}-based clients?`,
    a: `We run structured weekly cadences, shared project boards, and milestone-based delivery with timezone overlap for ${timezone}.`,
  },
  {
    q: `Can your team collaborate with our in-house team in ${country}?`,
    a: "Yes. We regularly work as an extension of internal product, marketing, and operations teams with transparent handoffs.",
  },
  {
    q: `Do you support post-launch optimization?`,
    a: "Yes. We offer stabilization, analytics-driven improvements, and roadmap support after launch.",
  },
  {
    q: `Where is your team based?`,
    a: "Obsidian Web Labs is headquartered in Delhi, India and serves businesses globally.",
  },
];
